import React, { useState, useEffect } from "react";
import { Card, Button } from "react-bootstrap";
import { toast } from "react-toastify";
import { createCheckoutSession } from "../ApiCalls/payment.services";
import spinner from "../Images/spinner.gif";
import { validate } from "react-email-validator";
import logo_dark from "../Images/logo_dark@3x.png";
import Popup from "./PopUp";

function Subscribe() {
  const [isLoading, setIsLoading] = useState(false);
  const [emailValue, setEmail] = useState("");
  const [showPopup, setShowPopup] = useState(false);
  const [popupText, setPopupText] = useState("");
  const [emailDisabled, setEmailInputDisabled] = useState(false);

  useEffect(() => {
    const params = new URLSearchParams(window.location.search);
    const emailParam = params.get("email");
    if (emailParam) {
      setEmailInputDisabled(true);
      setEmail(emailParam);
    }
  }, []);

  async function subscribe() {
    try {
      const validEmail = validate(emailValue);
      if (validEmail) {
        setIsLoading(true);
        const checkoutResponse = await createCheckoutSession(emailValue);
        window.location.replace(checkoutResponse.url);
      } else {
        toast.warning("Please enter valid email address");
      }
    } catch (error) {
      if (error.response.status === 409 || error.response.status === 404) {
        setShowPopup(true);
        setPopupText(error.response.data);
      } else if (error.response.status === 400)
        toast.warning(error.response.data.errors.Email[0]);
      else toast.error("Something went wrong");
    } finally {
      setIsLoading(false);
    }
  }

  return (
    <div className="center-screen subscription-checkout">
      <Card style={{ width: "35rem" }}>
        <Card.Body>
          {isLoading ? (
            <img src={spinner} className="spinner" alt="spinner"></img>
          ) : (
            <div>
              <Popup trigger={showPopup} setTrigger={setShowPopup}>
                {popupText}
              </Popup>
              <img
                src={logo_dark}
                className="premium-logo"
                alt="premium-logo"
              ></img>
              <div className="text-left">
                <p>
                  Before you can sign up to VPAR Premium we just need to verify
                  and confirm you have an existing VPAR account.
                </p>
                <p>
                  Please enter the email address that you used to register when
                  you first signed up to VPAR and click continue to continue.
                </p>
                <p>
                  If you have forgotten what email you used, or you used
                  Facebook or Apple ID when you first signed up, log in to the
                  app, click on the profile tab and go to settings and check or
                  update your email address there first.
                </p>
                <p>
                  Having difficulty? Not a problem, we can help. Email us on
                  <a href="mailto:support@vpar.com"> support@vpar.com</a>
                </p>
              </div>
              <input
                className="form-control"
                type="email"
                placeholder="Enter your email"
                onChange={(e) => setEmail(e.target.value)}
                disabled={emailDisabled}
                value={emailValue}
              />
              <Button
                variant="primary"
                className="subscribe-btn mt-4"
                onClick={subscribe}
              >
                Continue
              </Button>
            </div>
          )}
        </Card.Body>
      </Card>
    </div>
  );
}

export default Subscribe;
